<template>
  <div class="report">
    <div v-for="(arr,i) in list" class="PageNext">
    <div class="title">{{name}}</div>
    <div class="head"><div>运送⻋辆编号: {{carNo}}</div><div>运送⻋辆负责⼈: {{driver}}</div></div>

      <div v-for="(items,index) in arr">
        <table :class="{mt10:index>0}">
          <tr>
            <th rowspan="2">医疗卫⽣机构名称</th>
            <th colspan="2">感染性废物</th>
            <th colspan="2">损伤性废物</th>
            <th rowspan="2">医疗卫⽣机构交接⼈员签名</th>
          </tr>
          <tr>
            <th>体积 (箱)</th>
            <th>重量 (kg)</th>
            <th>体积 (箱)</th>
            <th>重量 (kg)</th>
          </tr>
          <tr v-for="item in items">
            <td>{{item[0]}}</td>
            <td>{{item[1]}}</td>
            <td>{{item[2]}}</td>
            <td>{{item[3]}}</td>
            <td>{{item[4]}}</td>
            <td><img :src="host+item[5]" v-if="item[5].length>4"> </td>
          </tr>
          <tr v-if="i+1===list.length">
            <td colspan="6" style="text-align: left;padding-left: 10px;line-height: 30px">
              <div>处置⼚医疗废物接收⼈员声明，我已接收上述数量的医疗废物，包装标识状态良好，若有问题在此注明。</div>
              <div>交物时间:________年____⽉____⽇____时____分</div>
              <div>接物⼈签名:</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Transfer",
    data(){
      return {
        name:"医疗废物运送登记卡",
        carNo:"",
        driver:"",
        list:[],
        host:""
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
          let arr=[];

          let count=res.list[0].length;
          let i=0;
          let tmp=[];
          let space=33;
          if (count===33){
            space=30
          }
          while(i<count){
            tmp.push(res.list[0][i]);
            if (i>0&&(i%space===0||i+1===count)){
              arr.push([tmp]);
              tmp=[];
            }
            i++;
          }
          console.log(arr);
          console.log(res.list.length);
          console.log(res.list[0].length);
          this.list=arr//res.list;
          this.carNo=res.car_no;
          this.driver=res.driver;
          this.host=res.host;
        } )
      },

    },
    created(){
      this.init()
    }
  }

</script>
<style media=print>
  .Noprint{display:none;}
  .PageNext{page-break-after: always;}
</style>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:35px;line-height: 35px;font-weight: bold;font-size: 18px;}
  table{
    border-collapse: collapse;
    width: 100%;
    margin-top:9px;
  }
  table td{border: 1px solid #000;font-size: 14px;height: 22px;}
  table th{border: 1px solid #000;font-size: 14px;height:22px;}

  .head{width:100%;text-align: left;font-size:14px}
  .head>div{width: 50%;display: inline-block;}
  .head>div:last-child{text-align: right}
  img{width:66px;height: 22px;margin: 0;padding: 0}
</style>



// WEBPACK FOOTER //
// src/view/report/transfer.vue